import UserSmallHeader from 'components/Headers/UserSmallHeader';
import { useEffect, useState } from 'react';
import { FaPlusCircle, FaCheckCircle, FaTrash, FaEdit } from 'react-icons/fa';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Modal,
  Row,
  Table,
} from 'reactstrap';
import api from 'services/api';
import { useQuery, useQueryClient } from 'react-query';
import { CircularProgress, FormGroup } from '@material-ui/core';
import toast from 'react-hot-toast';
import Header from 'components/Headers/Header';
import Swal from 'sweetalert2';
import { ContainerButtons, Th, Td } from './styles';
import ProdutoCategoriaModel from '../../../models/ProdutoCategoria';

interface IProdutoCategoria extends ProdutoCategoriaModel {
  novo?: boolean;
}

export default function ProdutoCategoria(): JSX.Element {
  const [formModalState, setFormModalState] = useState(false);
  const [descricao, setDescricao] = useState('');
  const [subprojeto, setSubprojeto] = useState('');
  const [significado, setSignificado] = useState('');
  const [prodCatId, setProdCatId] = useState<null | number>(null);
  const queryClient = useQueryClient();
  const [isSaving, setIsSaving] = useState(false);

  const { data: queryProdutoCategoria, isLoading } = useQuery(
    `produto-categoria`,
    async () => {
      async function getData(): Promise<ProdutoCategoriaModel[]> {
        const response = await api.get('/produto-categoria');
        return response.data;
      }

      const dataProdutoCategoria = await getData();
      return dataProdutoCategoria;
    },
  );

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  function limparCampos() {
    setDescricao('');
    setSubprojeto('');
    setSignificado('');
    setProdCatId(null);
  }

  async function handleSave() {
    if (!descricao || !subprojeto || descricao === '' || subprojeto === '') {
      toast.error('É necessário informar a descrição e o subprojeto.');
      return;
    }

    setIsSaving(true);
    const toastId = toast.loading('Salvando...');

    try {
      if (prodCatId) {
        await api.put(`/produto-categoria/${prodCatId}`, {
          descricao,
          subprojeto,
          significado,
        });
      } else {
        await api.post(`/produto-categoria`, {
          descricao,
          subprojeto,
          significado,
        });
      }
      toast.success('Registro salvo');
    } finally {
      toast.dismiss(toastId);
    }
    setIsSaving(false);

    queryClient.invalidateQueries({ queryKey: ['produto-categoria'] });
    limparCampos();
    setFormModalState(!formModalState);
  }

  async function handleDelete(id: number) {
    if (id) {
      const resp = await api.get(`/produto-categoria/produto-associados/${id}`);

      const produtos = resp.data;

      let msg = 'Deseja excluir o Registro?';
      if (produtos.length > 0) {
        msg += '<br />';
        msg += '<br />';
        msg += `<div style="font-size:14px; text-align:left;">`;
        msg += `<span style="color:#f71b1b; font-weight:bold;">Existem produtos atrelados à categoria:</span><br />`;
        msg += `<ul style="padding-left:18px; margin:5px 0; font-size:12px;">`;
        msg += produtos.map((item: any) => `<li>${item.nome}</li>`).join('');
        msg += `</ul>`;
        msg += `<span style="text-decoration:underline; margin-top: 10px;">Ao excluir a categoria, estes produtos ficarão sem categoria.</span>`;
        msg += `<div>Deseja continuar?</div>`;
        msg += `</div>`;
      }
      Swal.fire({
        title: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      }).then(async result => {
        if (result.isConfirmed) {
          const toastId = toast.loading('Excluindo');
          setIsSaving(true);
          try {
            await api.delete(`/produto-categoria/${id}`);
            Swal.close();
            queryClient.invalidateQueries({ queryKey: ['produto-categoria'] });
            toast.success('Registro excluído');
          } finally {
            setIsSaving(false);
            toast.dismiss(toastId);
          }
        }
      });
    } else {
      toast.error('erro ao excluir registro!');
    }
  }

  async function handleInsert() {
    setFormModalState(!formModalState);
  }
  async function handleUpdate(prodCategoria: IProdutoCategoria) {
    setDescricao(prodCategoria.descricao);
    setSubprojeto(prodCategoria?.subprojeto ?? '');
    setSignificado(prodCategoria?.significado ?? '');
    setProdCatId(prodCategoria.id);
    setFormModalState(!formModalState);
  }

  return (
    <>
      <Header showCards={false} />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <FormGroup className="mb-4">
              <InputGroup>
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  disabled={isLoading}
                  onClick={handleInsert}
                >
                  <FaPlusCircle />
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <div className="col">
            <Modal
              className="modal-dialog-centered"
              size="sm"
              isOpen={formModalState}
              toggle={() => {
                limparCampos();
                setFormModalState(!formModalState);
              }}
            >
              <div className="modal-body p-0">
                <Card className="bg-secondary shadow border-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form">
                      <FormGroup className="mb-3">
                        <small>Descrição</small>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Descrição"
                            value={descricao}
                            type="text"
                            onChange={e => {
                              setDescricao(e.target.value);
                            }}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Subprojeto</small>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Subprojeto"
                            value={subprojeto}
                            type="text"
                            onChange={e => {
                              setSubprojeto(e.target.value);
                            }}
                          />
                        </InputGroup>
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <small>Significado</small>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Significado"
                            value={significado}
                            type="text"
                            onChange={e => {
                              setSignificado(e.target.value);
                            }}
                          />
                        </InputGroup>
                      </FormGroup>

                      <div className="text-center">
                        <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          disabled={isLoading || isSaving}
                          onClick={handleSave}
                        >
                          Salvar
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <Row>
                  <Col sm="9">
                    <h3 className="mb-0">Categorias de Produtos</h3>
                  </Col>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Descrição</th>
                    <th>Subprojeto</th>
                    <th>Significado</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <CircularProgress
                      className="mt-2 ml-2"
                      color="inherit"
                      size={10}
                    />
                  )}
                  {!isLoading &&
                    queryProdutoCategoria &&
                    queryProdutoCategoria.map(item => {
                      return (
                        <tr key={item.id}>
                          <td className="py-2">{item.descricao}</td>
                          <td className="py-2">{item?.subprojeto}</td>
                          <td className="py-2">{item.significado}</td>
                          <td className="py-2">
                            <div className="float-right">
                              <Button
                                size="sm"
                                className="btn-icon"
                                color="warning"
                                type="button"
                                disabled={isLoading}
                                onClick={() => {
                                  handleUpdate(item);
                                }}
                              >
                                <FaEdit />
                              </Button>
                              <Button
                                size="sm"
                                className="btn-icon"
                                color="danger"
                                type="button"
                                disabled={isLoading}
                                onClick={() => {
                                  handleDelete(item.id);
                                }}
                              >
                                <FaTrash />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
